import * as React from 'react';

import { PropertyDirectFeedbackPromptId } from '@shared-ui/lodging-property-details';
import { ViewLarge, Viewport, ViewSmall } from '@shared-ui/viewport-context';

import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { UitkSpacing } from 'uitk-react-spacing';

import { SharedUiWrapperProps, withSharedUiPropertyDetails } from '../shared-ui/details/shared-ui-property-details';

const Component = ({ inputs }: { inputs: SharedUiWrapperProps['inputs'] }) => (
  <UitkSpacing margin={{ blockstart: 'four', blockend: 'six' }}>
    <div>
      <Viewport>
        <ViewLarge>
          <PropertyDirectFeedbackPromptId inputs={inputs} contextValues={[{ key: 'property_id', value: inputs?.propertyId || '' }]} />
        </ViewLarge>
        <ViewSmall>
          <UitkLayoutFlex justifyContent="center">
            <UitkLayoutFlexItem>
              <div>
                <PropertyDirectFeedbackPromptId inputs={inputs} contextValues={[{ key: 'property_id', value: inputs?.propertyId || '' }]} />
              </div>
            </UitkLayoutFlexItem>
          </UitkLayoutFlex>
        </ViewSmall>
      </Viewport>
    </div>
  </UitkSpacing>
);

const PropertyAboutThisPropertyDirectFeedback: React.FC<SharedUiWrapperProps> = React.memo(({ inputs }) => <Component inputs={inputs} />);

export const PropertyAboutThisPropertyDirectFeedbackWrapper = withSharedUiPropertyDetails<SharedUiWrapperProps>(
  PropertyAboutThisPropertyDirectFeedback
);
PropertyAboutThisPropertyDirectFeedbackWrapper.displayName = 'PropertyAboutThisPropertyDirectFeedbackWrapper';
